import { useQuery } from "@tanstack/react-query"

import { v1FetchUserAddress } from "@be-miniapp/api"

const savedUserAddressesQueryKey = {
  all: ["saved-user-addresses"],
}

export const savedUserAddressQuery = {
  queryKey: savedUserAddressesQueryKey.all,
  queryFn: async () => {
    const data = await v1FetchUserAddress()
    return data?.addresses ?? []
  },
  placeholderData: [],
}

export const useSavedUserAddresses = () => {
  return useQuery(savedUserAddressQuery)
}
